import { useLocation } from '@gatsbyjs/reach-router';

export const useTypedLocation = <T>(): T | undefined => {
  const location = useLocation();
  return location.state as T | undefined;
};
